module.exports = __webpack_public_path__ + "static/img/pic_azh_szhzx_gzfw.cf1be2f4.png";